import { useUser } from "../useUser"

/**
 * Handles all necessary actions after logging out a user
 */
export function afterLogoutActions() {
  const { deleteUser } = useUser()

  // Remove the user from storage
  deleteUser()

  // Any additional cleanup can be added here
}

/**
 * Updates the user object with new data
 */
export function mergeUser(user: User): User {
  if (isServer) return user

  const { mergeUser: _mergeUser } = useUser()

  user.loginTimestamp = Date.now()
  _mergeUser(user)

  return user
}
